import { useNavigate } from 'react-router-dom';
import { theme, buttonStyles, spacing, typography, mergeStyles } from '../styles/theme';
import SimpleHeader from '../components/SimpleHeader';

export default function PaymentCancel() {
  const navigate = useNavigate();

  return (
    <>
      <SimpleHeader />
      <div style={{
        minHeight: '100vh',
        backgroundColor: theme.bg.primary,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: spacing.xl
      }}>
        <div style={{
          maxWidth: '500px',
          width: '100%',
          backgroundColor: 'white',
          padding: spacing['4xl'],
          borderRadius: '12px',
          boxShadow: theme.shadow.large,
          textAlign: 'center'
        }}>
          {/* Cancel icon */}
          <div style={{
            width: '80px',
            height: '80px',
            borderRadius: '50%',
            backgroundColor: theme.bg.secondary,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto',
            marginBottom: spacing.xl,
            fontSize: '40px'
          }}>
            ✕
          </div>

          <h1 style={{
            color: theme.text.primary,
            fontFamily: typography.fontFamily.primary,
            fontSize: typography.fontSize['3xl'],
            marginBottom: spacing.lg
          }}>
            Payment Cancelled
          </h1>

          <p style={{
            color: theme.text.secondary,
            fontSize: typography.fontSize.base,
            lineHeight: typography.lineHeight.relaxed,
            marginBottom: spacing['2xl']
          }}>
            No charges were made. You can upgrade to premium anytime from your account.
          </p>

          <div style={{ display: 'flex', gap: spacing.md }}>
            <button
              onClick={() => navigate('/')}
              style={mergeStyles(
                buttonStyles.base,
                buttonStyles.secondary,
                { flex: 1 }
              )}
            >
              Back to Home
            </button>
            
            <button
              onClick={() => {
                navigate('/');
                // Could trigger upgrade modal here if you want
              }}
              style={mergeStyles(
                buttonStyles.base,
                buttonStyles.primary,
                { flex: 1 }
              )}
            >
              Try Again
            </button>
          </div>
        </div>
      </div>
    </>
  );
}